// =========================
// PRODUCT GALLERY
// =========================

const thumbs = document.querySelectorAll(
  '.product-thumb-btn'
);

const mainImage = document.getElementById(
  'ProductMainImage'
);

if(thumbs.length && mainImage){

  thumbs.forEach(button => {

    button.addEventListener('click', () => {

      thumbs.forEach(btn => {
        btn.classList.remove('active');
      });

      button.classList.add('active');

      mainImage.src = button.dataset.image;

    });

  });

}

// =========================
// PRODUCT VARIANTS
// =========================

const variantButtons = document.querySelectorAll(
  '.product-variant-btn'
);

const variantIdInput = document.querySelector(
  'input[name="id"]'
);

const productPrice = document.getElementById(
  'ProductPrice'
);

const comparePrice = document.getElementById(
  'ProductComparePrice'
);

const variantMedidas = document.getElementById(
  'VariantMedidas'
);

if(
  variantButtons.length &&
  window.productVariants
){

  variantButtons.forEach(button => {

    button.addEventListener('click', () => {

      const variantId =
        button.dataset.variantId;

      const variant =
        window.productVariants.find(
          v => v.id == variantId
        );

      if(!variant) return;

      // ACTIVE

      variantButtons.forEach(btn => {
        btn.classList.remove('active');
      });

      button.classList.add('active');

      // CHANGE VARIANT ID

      if(variantIdInput){

        variantIdInput.value =
          variant.id;

      }

      // CHANGE PRICE

      if(productPrice){

        productPrice.innerHTML =
          variant.price;

      }

      // CHANGE COMPARE PRICE

      if(comparePrice){

        if(variant.compare_at_price){

          comparePrice.style.display =
            'inline-block';

          comparePrice.innerHTML =
            variant.compare_at_price;

        }else{

          comparePrice.style.display =
            'none';

        }

      }

      // CHANGE IMAGE
      // IF VARIANT HAS IMAGE -> USE IT
      // ELSE -> KEEP MAIN PRODUCT IMAGE

      if(
        mainImage &&
        variant.image
      ){

        mainImage.src =
          variant.image;

      }

      // CHANGE MEDIDAS

      if(
        variantMedidas &&
        variant.medidas
      ){

        variantMedidas.innerHTML =
          variant.medidas;

      }

    });

  });

}

// =========================
// QUANTITY
// =========================

const quantityWrappers = document.querySelectorAll(
  '.product-quantity'
);

if(quantityWrappers.length){

  quantityWrappers.forEach((wrapper)=>{

    const minusBtn = wrapper.querySelector(
      '.quantity-btn.minus'
    );

    const plusBtn = wrapper.querySelector(
      '.quantity-btn.plus'
    );

    const quantityInput = wrapper.querySelector(
      'input'
    );

    if(
      minusBtn &&
      plusBtn &&
      quantityInput
    ){

      minusBtn.addEventListener(
        'click',
        ()=>{

          let current =
            parseInt(quantityInput.value) || 1;

          if(current > 1){

            quantityInput.value =
              current - 1;

          }

        }
      );

      plusBtn.addEventListener(
        'click',
        ()=>{

          let current =
            parseInt(quantityInput.value) || 1;

          quantityInput.value =
            current + 1;

        }
      );

    }

  });

}

// =========================
// BUY NOW
// =========================

const buyNowButton = document.getElementById(
  'ProductBuyNow'
);

if(buyNowButton){

  buyNowButton.addEventListener('click', () => {

    const variantId =
      variantIdInput.value;

    const quantity =
      document.querySelector(
        '.product-quantity input'
      ).value || 1;

    window.location.href =
      '/cart/' + variantId + ':' + quantity;

  });

}

// =========================
// ACCORDIONS AUTO CLOSE
// =========================

const accordions = document.querySelectorAll(
  '.product-accordion'
);

if(accordions.length){

  accordions.forEach((accordion)=>{

    accordion.addEventListener(
      'toggle',
      () => {

        if(accordion.open){

          accordions.forEach((item)=>{

            if(item !== accordion){

              item.removeAttribute('open');

            }

          });

        }

      }
    );

  });

}